import type { ReactNode } from 'react';

import styles from './PortalComponents.module.css';

export function PageHeader({
  title,
  subtitle,
  breadcrumbs,
  actions,
}: {
  title: string;
  subtitle?: string;
  breadcrumbs?: ReactNode;
  actions?: ReactNode;
}): React.JSX.Element {
  return (
    <header className={styles.pageHeader}>
      <div className={styles.pageHeaderMain}>
        {breadcrumbs}
        <h1 className={styles.pageTitle}>{title}</h1>
        {subtitle !== undefined && <p className={styles.pageSubtitle}>{subtitle}</p>}
      </div>
      {actions !== undefined && <div className={styles.pageHeaderActions}>{actions}</div>}
    </header>
  );
}
